

import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  fetchFullDetailsNotes,
  fetchNotesCatagory,
  fetchNotesCatalogDetails,
} from "../services/operations/notesAPI";
import { formatDate } from "../services/formatDate";
import * as pdfjsLib from "pdfjs-dist/webpack";
import PDFopener from "../components/Common/PDFopener";
import ConfirmationModal from "../components/Common/ConfirmationModal";
import UnderDevelopmentPage from "../components/Common/UnderdevelopmentPage";
function NotesCatalog() {
  const { token } = useSelector((state) => state.auth);
  const { notesName } = useParams();
  const navigate = useNavigate();
  const [confirmationModal, setConfirmationModal] = useState(null);
  const [catalogPageData, setCatalogPageData] = useState(null);
  const [categoryId, setCategoryId] = useState("");
  const [notes, setNotes] = useState([]);
  const [pdfPreviews, setPdfPreviews] = useState({});
  const [selectedNoteDetails, setSelectedNoteDetails] = useState(null);
  const [loading, setLoading] = useState(false);

  // State for managing visible notes
  const [visibleNotesCount, setVisibleNotesCount] = useState(6);

  // Fetch category by name
  useEffect(() => {
    setLoading(true);
    const fetchCategories = async () => {
      try {
        const res = await fetchNotesCatagory();
        if (!res) return <UnderDevelopmentPage />;
        const category = res.find(
          (ct) =>
            ct.name.split(" ").join("-").toLowerCase() ===
            notesName.toLowerCase()
        );
        setCategoryId(category?._id || "");
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
      setLoading(false);
    };
    fetchCategories();
  }, [notesName]);

  // Fetch notes for the selected category
  useEffect(() => {
    if (categoryId) {
      setLoading(true);
      const fetchCatalogDetails = async () => {
        try {
          const res = await fetchNotesCatalogDetails({ categoryId }, token);
          setCatalogPageData(res);
          setNotes(res?.selectedCategory?.notes || []);
        } catch (error) {
          console.error("Error fetching catalog details:", error);
        }
        setLoading(false);
      };
      fetchCatalogDetails();
    }
  }, [categoryId, token]);

  // Generate PDF Previews
  const handlePdfPreview = async (noteId, pdfUrl) => {
    try {
      const response = await fetch(pdfUrl);
      const pdfData = await response.arrayBuffer();
      const pdf = await pdfjsLib.getDocument(pdfData).promise;
      const page = await pdf.getPage(1);
      const canvas = document.createElement("canvas");
      const viewport = page.getViewport({ scale: 1.5 });
      const context = canvas.getContext("2d");
      canvas.width = viewport.width;
      canvas.height = viewport.height;
      await page.render({ canvasContext: context, viewport }).promise;
      setPdfPreviews((prev) => ({ ...prev, [noteId]: canvas.toDataURL() }));
    } catch (error) {
      console.error("Error generating PDF preview:", error);
    }
  };

  useEffect(() => {
    notes.forEach((note) => {
      if (note.NotesPdf && !pdfPreviews[note._id]) {
        handlePdfPreview(note._id, note.NotesPdf);
      }
    });
  }, [notes, pdfPreviews]);

    // Handle case where no notes are found
      if (!categoryId || catalogPageData?.success === false) {
        return <UnderDevelopmentPage />;
      }

  // Fetch full details of a note
  const fetchNotesFullDetails = async (noteId) => {
    if (!token) {
      setConfirmationModal({
        text1: "You are not logged in!",
        text2: "Please login to View Notes Details.",
        btn1Text: "Login",
        btn1Handler: () => navigate("/login"),
        btn2Text: "Close",
        btn2Handler: () => setConfirmationModal(null),
      });
      return;
    }

    try {
      const res = await fetchFullDetailsNotes({ notesId: noteId }, token);
      setSelectedNoteDetails(res);
    } catch (error) {
      console.error("Error fetching note details:", error);
    }
  };

  const handlePDFOpener = (pdfUrl) => {
    if (!token) {
      setConfirmationModal({
        text1: "You are not logged in!",
        text2: "Please login to Access Notes.",
        btn1Text: "Login",
        btn1Handler: () => navigate("/login"),
        btn2Text: "Close",
        btn2Handler: () => setConfirmationModal(null),
      });
      return;
    }

    // If logged in, open the PDF
    PDFopener({ pdfUrl });
  };

  if (loading) {
    return (
      <div className="grid min-h-[calc(100vh-3.5rem)] place-items-center">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div>
      {/* Hero Section */}
      <div className="bg-pure-greys-150 py-8 px-4">
        <div className="container mx-auto max-w-6xl">
          <p className="text-sm text-gray-600">
            Home / Notes /{" "}
            <span className="font-semibold text-pink-500">
              {catalogPageData?.selectedCategory?.name || "Loading..."}
            </span>
          </p>
          <h1 className="text-3xl font-bold text-gray-800 mt-4">
            {catalogPageData?.selectedCategory?.name}
          </h1>
          <p className="text-gray-600 mt-2 max-w-3xl">
            {catalogPageData?.selectedCategory?.description}
          </p>
        </div>
      </div>

      {/* Notes Section */}
      <div className="container mx-auto py-10 px-4 max-w-6xl">
        <h2 className="text-2xl font-semibold mb-6">Notes to Get You Started</h2>
        {notes.length === 0 ? (
          <div className="flex items-center justify-center h-64 text-pure-greys-500 bg-pure-greys-200 rounded-lg">
            No Notes Found🙂
          </div>
        ) : (
          <div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {notes.slice(0, visibleNotesCount).map((note) => (
                <div
                  key={note._id}
                  className="bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-xl transition"
                >
                  <img
                    src={pdfPreviews[note._id] || "/default-pdf-preview.png"}
                    alt={note.NotesName}
                    className="w-full h-48 object-cover"
                  />
                  <div className="p-4">
                    <h3 className="font-bold text-lg text-pure-greys-800 truncate">
                      Notes: {note.NotesName}
                    </h3>
                    <p className="text-sm text-gray-600 mt-2">
                      description: {note.NotesDescription?.substr(0, 50)}...
                    </p>
                    <p className="text-xs text-gray-500 mt-2">
                      Created: {formatDate(note.createdAt)}
                    </p>
                  </div>
                  <div className="p-4 flex justify-between">
                  <button
                      className="bg-blue-500 text-white text-sm px-4 py-2 rounded-lg hover:bg-blue-600 transition"
                      onClick={() => fetchNotesFullDetails(note._id)}
                    >
                      View Details
                    </button>
                    <button
              className="bg-pure-greys-200 text-gray-800 text-sm px-4 py-2 rounded-lg hover:bg-pure-greys-300 transition"
            >
               {
                          token ? <button><PDFopener pdfUrl={note.NotesPdf} /></button> : <button onClick={handlePDFOpener}>Open pdf</button>
                        }
            </button>
                  </div>
                </div>
              ))}
            </div>

            {selectedNoteDetails && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center px-2">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96 relative mx-auto">
            <button
              className="absolute top-4 right-4 text-gray-600"
              onClick={() => setSelectedNoteDetails(null)}
            >
              &times;
            </button>
                    <div className="flex items-center gap-3 mt-4">
            <img
              src={`https://api.dicebear.com/5.x/initials/svg?seed=${selectedNoteDetails.instructor.firstName} ${selectedNoteDetails.instructor.lastName}`}
              alt={`${selectedNoteDetails.instructor.firstName} ${selectedNoteDetails.instructor.lastName}`}
              className="h-12 w-12 rounded-full object-cover border border-pure-greys-100"
            />
            </div>
               <p className="text-lg font-semibold text-pure-greys-800">
              {`${selectedNoteDetails.instructor.firstName} ${selectedNoteDetails.instructor.lastName}`}
               </p>
               <p className="text-xs text-blue-100">Instructor</p>
            <h3 className="text-lg font-semibold mb-4">
              {selectedNoteDetails.NotesName}
            </h3>
            <p className="text-sm text-gray-700 mb-4">
              {selectedNoteDetails.NotesDescription}
            </p>
            <p className="text-xs text-gray-500">
              Created: {formatDate(selectedNoteDetails.createdAt)}
            </p>
            <button
              className="mt-6 bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
              onClick={() => setSelectedNoteDetails(null)}
            >
              Close
            </button>
          </div>
        </div>
      )}

            {/* View More / View Less Buttons */}
            <div className="text-center mt-6">
              {visibleNotesCount < notes.length ? (
                <button
                  className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600"
                  onClick={() => setVisibleNotesCount(visibleNotesCount + 6)}
                >
                  View More Notes
                </button>
              ) : (
                <button
                  className="bg-pure-greys-500 text-white px-6 py-2 rounded-lg hover:bg-pure-greys-600"
                  onClick={() => setVisibleNotesCount(6)}
                >
                  View Less Notes
                </button>
              )}
            </div>
          </div>
        )}
      </div>

      {
        confirmationModal && <ConfirmationModal modalData={confirmationModal} />
      }

     
    </div>
  );
}

export default NotesCatalog;





// import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import { useNavigate, useParams } from "react-router-dom";
// import { fetchFullDetailsNotes, fetchNotesCatagory, fetchNotesCatalogDetails } from "../services/operations/notesAPI";
// import { formatDate } from "../services/formatDate";
// import * as pdfjsLib from "pdfjs-dist/webpack";
// import PDFopener from "../components/Common/PDFopener";
// import UnderDevelopmentPage from "../components/Common/UnderdevelopmentPage";
// function NotesCatalog() {
//   const { token } = useSelector((state) => state.auth);
//   const { notesName } = useParams();
//   const navigate = useNavigate();
//   const [confirmationModal, setConfirmationModal] = useState(null);
//   const [catalogPageData, setCatalogPageData] = useState(null);
//   const [categoryId, setCategoryId] = useState("");
//   const [notes, setNotes] = useState([]);
//   const [pdfPreviews, setPdfPreviews] = useState({});
//   const [selectedNoteDetails, setSelectedNoteDetails] = useState(null);
//   const [loading, setLoading] = useState(false);

//   // State for managing visible notes
//   const [visibleNotesCount, setVisibleNotesCount] = useState(6);

//   // Fetch category by name
//   useEffect(() => {
//     setLoading(true);
//     const fetchCategories = async () => {
//       try {
//         const res = await fetchNotesCatagory();
//         const category = res.find(
//           (ct) => ct.name.split(" ").join("-").toLowerCase() === notesName.toLowerCase()
//         );
//         setCategoryId(category?._id || "");
//       } catch (error) {
//         console.error("Error fetching categories:", error);
//       }
//       setLoading(false);
//     };
//     fetchCategories();
//   }, [notesName]);

//   // Fetch notes for the selected category
//   useEffect(() => {
//     if (categoryId) {
//       setLoading(true);
//       const fetchCatalogDetails = async () => {
//         try {
//           const res = await fetchNotesCatalogDetails({ categoryId }, token);
//           setCatalogPageData(res);
//           setNotes(res?.selectedCategory?.notes || []);
//         } catch (error) {
//           console.error("Error fetching catalog details:", error);
//         }
//         setLoading(false);
//       };
//       fetchCatalogDetails();
//     }
//   }, [categoryId, token]);

  

//   // Generate PDF Previews
//   const handlePdfPreview = async (noteId, pdfUrl) => {
//     try {
//       const response = await fetch(pdfUrl);
//       const pdfData = await response.arrayBuffer();
//       const pdf = await pdfjsLib.getDocument(pdfData).promise;
//       const page = await pdf.getPage(1);
//       const canvas = document.createElement("canvas");
//       const viewport = page.getViewport({ scale: 1.5 });
//       const context = canvas.getContext("2d");
//       canvas.width = viewport.width;
//       canvas.height = viewport.height;
//       await page.render({ canvasContext: context, viewport }).promise;
//       setPdfPreviews((prev) => ({ ...prev, [noteId]: canvas.toDataURL() }));
//     } catch (error) {
//       console.error("Error generating PDF preview:", error);
//     }
//   };

//   useEffect(() => {
//     notes.forEach((note) => {
//       if (note.NotesPdf && !pdfPreviews[note._id]) {
//         handlePdfPreview(note._id, note.NotesPdf);
//       }
//     });
//   }, [notes, pdfPreviews]);

//   // Fetch full details of a note
//   const fetchNotesFullDetails = async (noteId) => {
//     try {
//       const res = await fetchFullDetailsNotes({ notesId: noteId }, token);
//       setSelectedNoteDetails(res);
//     } catch (error) {
//       console.error("Error fetching note details:", error);
//     }
//   };

//   const handlePDFOpener = () => {
//     setConfirmationModal({
//       text1: "You are not logged in!",
//       text2: "Please login to Access Notes.",
//       btn1Text: "Login",
//       btn1Handler: () => navigate("/login"),
//       btn2Text: "Close",
//       btn2Handler: () => setConfirmationModal(null),
//     });
//   };

//   if (loading) {
//     return (
//       <div className="grid min-h-[calc(100vh-3.5rem)] place-items-center">
//         <div className="spinner"></div>
//       </div>
//     );
//   }
//     // Handle case where no notes are found
//   if (!categoryId || catalogPageData?.success === false) {
//     return <UnderDevelopmentPage />;
//   }

//   return (
//     <div>
//       {/* Hero Section */}
//       <div className="bg-pure-greys-150 py-8 px-4">
//         <div className="container mx-auto max-w-6xl">
//           <p className="text-sm text-gray-600">
//             Home / Notes /{" "}
//             <span className="font-semibold text-pink-500">
//               {catalogPageData?.selectedCategory?.name || "Loading..."}
//             </span>
//           </p>
//           <h1 className="text-3xl font-bold text-gray-800 mt-4">
//             {catalogPageData?.selectedCategory?.name}
//           </h1>
//           <p className="text-gray-600 mt-2 max-w-3xl">
//             {catalogPageData?.selectedCategory?.description}
//           </p>
//         </div>
//       </div>

//       {/* Notes Section */}
//       <div className="container mx-auto py-10 px-4 max-w-6xl">
//         <h2 className="text-2xl font-semibold mb-6">Notes to Get You Started</h2>
//         {notes.length === 0 ? (
//           <div className="flex items-center text-xl justify-center h-64 text-pure-greys-500 bg-pure-greys-200 rounded-lg">
//             No Notes Found🙂
//           </div>
//         ) : (
//           <div>
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//               {notes.slice(0, visibleNotesCount).map((note) => (
//                 <div
//                   key={note._id}
//                   className="bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-xl transition"
//                 >
//                   <img
//                     src={pdfPreviews[note._id] || "/default-pdf-preview.png"}
//                     alt={note.NotesName}
//                     className="w-full h-48 object-cover"
//                   />
//                   <div className="p-4">
//                     <h3 className="font-bold text-lg text-pure-greys-800 truncate">
//                       Notes: {note.NotesName}
//                     </h3>
//                     <p className="text-sm text-gray-600 mt-2">
//                       description: {note.NotesDescription?.substr(0, 50)}...
//                     </p>
//                     <p className="text-xs text-gray-500 mt-2">
//                       Created: {formatDate(note.createdAt)}
//                     </p>
//                   </div>
//                   <div className="p-4 flex justify-between">
//                     <button
//                       className="bg-blue-500 text-white text-sm px-4 py-2 rounded-lg hover:bg-blue-600 transition"
//                       onClick={() => fetchNotesFullDetails(note._id)}
//                     >
//                       View Details
//                     </button>
//                     <button
//               className="bg-pure-greys-200 text-gray-800 text-sm px-4 py-2 rounded-lg hover:bg-pure-greys-300 transition"
//             >
//               {token ? (
//                 <PDFopener pdfUrl={note.NotesPdf} />
//               ) : (
//                 <button onClick={handlePDFOpener}>Open PDF</button>
//               )}
//             </button>
//                   </div>
//                 </div>
//               ))}
//             </div>
//       {/* Details Modal */}
//       {selectedNoteDetails && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center px-2">
//           <div className="bg-white p-6 rounded-lg shadow-lg w-96 relative mx-auto">
//             <button
//               className="absolute top-4 right-4 text-gray-600"
//               onClick={() => setSelectedNoteDetails(null)}
//             >
//               &times;
//             </button>
//                     <div className="flex items-center gap-3 mt-4">
//             <img
//               src={`https://api.dicebear.com/5.x/initials/svg?seed=${selectedNoteDetails.instructor.firstName} ${selectedNoteDetails.instructor.lastName}`}
//               alt={`${selectedNoteDetails.instructor.firstName} ${selectedNoteDetails.instructor.lastName}`}
//               className="h-12 w-12 rounded-full object-cover border border-pure-greys-100"
//             />
//             </div>
//                <p className="text-lg font-semibold text-pure-greys-800">
//               {`${selectedNoteDetails.instructor.firstName} ${selectedNoteDetails.instructor.lastName}`}
//                </p>
//                <p className="text-xs text-blue-100">Instructor</p>
//             <h3 className="text-lg font-semibold mb-4">
//               {selectedNoteDetails.NotesName}
//             </h3>
//             <p className="text-sm text-gray-700 mb-4">
//               {selectedNoteDetails.NotesDescription}
//             </p>
//             <p className="text-xs text-gray-500">
//               Created: {formatDate(selectedNoteDetails.createdAt)}
//             </p>
//             <button
//               className="mt-6 bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
//               onClick={() => setSelectedNoteDetails(null)}
//             >
//               Close
//             </button>
//           </div>
//         </div>
//       )}
//             {/* View More / View Less Buttons */}
//             <div className="text-center mt-6">
//               {visibleNotesCount < notes.length ? (
//                 <button
//                   className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600"
//                   onClick={() => setVisibleNotesCount(visibleNotesCount + 6)}
//                 >
//                   View More Notes
//                 </button>
//               ) : (
//                 <button
//                   className="bg-pure-greys-500 text-white px-6 py-2 rounded-lg hover:bg-pure-greys-600"
//                   onClick={() => setVisibleNotesCount(6)}
//                 >
//                   View Less Notes
//                 </button>
//               )}
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default NotesCatalog;



// import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import { useNavigate, useParams } from "react-router-dom";
// // import UnderDevelopmentPage from "../components/Common/UnderDevelopmentPage";
// import { fetchFullDetailsNotes, fetchNotesCatagory, fetchNotesCatalogDetails } from "../services/operations/notesAPI";

// import { Table, Tbody, Td, Th, Thead, Tr } from "react-super-responsive-table";
// import * as pdfjsLib from "pdfjs-dist/webpack";
// import { formatDate } from "../services/formatDate";
// import PDFopener from "../components/Common/PDFopener";
// import ConfirmationModal from "../components/Common/ConfirmationModal";
// import UnderDevelopmentPage from "../components/Common/UnderdevelopmentPage";
// function NotesCatalog() {
//   const { token } = useSelector((state) => state.auth);
//   const { notesName } = useParams();
//   const navigate = useNavigate()

//   const [catalogPageData, setCatalogPageData] = useState(null);
//   const [selectedNoteDetails, setSelectedNoteDetails] = useState(null); 
//   const [categoryId, setCategoryId] = useState("");
//   const [pdfPreview, setPdfPreview] = useState(null);
//   const [notes, setNotes] = useState([]);
//   const [instructorDetailModal,setInstructorDetailModal] = useState(null)
//   const [confirmationModal,setConfirmationModal] = useState(null)
//   const [loading,setLoading] = useState(false)
  
//   const [pdfPreviews, setPdfPreviews] = useState({});

//   // Fetch All Categories
//   // console.log(notesName,"akjbnfjasdbfjb")
//   useEffect(() => {
//     setLoading(true)
//     const fetchCategories = async () => {
//       try {
//         const res = await fetchNotesCatagory();
//         if (!res) return <UnderDevelopmentPage />;
//         // console.log(res)
        
//         const category_id = res.find(
//   (ct) => ct.name.split(" ").join("-").toLowerCase() === notesName.toLowerCase()
// );


//         setCategoryId(category_id);
//         // console.log(category_id)
//       } catch (error) {
//         // console.error("Could not fetch Categories.", error);
//       }
//     };
//     fetchCategories();
//     setLoading(false)
//   }, [notesName]);

//   // Fetch catalog data for the selected category
//   useEffect(() => {
    
//     if (categoryId) {
//       setLoading(true)
//       const fetchCatalogDetails = async () => {
//         try {
//           const res = await fetchNotesCatalogDetails({ categoryId }, token);
//           setCatalogPageData(res);
//           setNotes(res?.selectedCategory?.notes || []);
          
             
//         } catch (error) {
//           // console.error("Error fetching catalog details:", error);
//         }
//       };
//       fetchCatalogDetails();
//     }
//      setLoading(false)
//   }, [categoryId, token]);

//   // Fetch full details of a selected note
//   const fetchNotesFullDetails = async (noteId) => {
//     try {
//       const res = await fetchFullDetailsNotes({ notesId: noteId }, token);
//       setSelectedNoteDetails(res); 
//       setInstructorDetailModal(true)
    
//       // console.log("Fetched note details:", selectedNoteDetails.instructor.firstName);
//     } catch (error) {
//       // console.error("Error fetching note details:", error);
//     }
//   };

// const handlePdfPreview = async (noteId, pdfUrl) => {
//   try {
//     const response = await fetch(pdfUrl);
//     const pdfData = await response.arrayBuffer();

//     if (!pdfData) {
//       throw new Error("Failed to load PDF data");
//     }

//     const pdf = await pdfjsLib.getDocument(pdfData).promise;

//     if (pdf.numPages < 1) {
//       throw new Error("PDF has no pages");
//     }

//     const page = await pdf.getPage(1); // Render the first page
//     const scale = 1.5;
//     const viewport = page.getViewport({ scale });
//     const canvas = document.createElement("canvas");
//     const context = canvas.getContext("2d");

//     canvas.width = viewport.width;
//     canvas.height = viewport.height;

//     await page.render({
//       canvasContext: context,
//       viewport: viewport,
//     }).promise;

//     // Convert canvas to data URL for preview
//     setPdfPreviews((prev) => ({
//       ...prev,
//       [noteId]: canvas.toDataURL(), // Set preview for the specific note
//     }));
//   } catch (error) {
//     console.error("Error generating PDF preview:", error);
//     setPdfPreviews((prev) => ({
//       ...prev,
//       [noteId]: null, // Optionally reset if there's an error
//     }));
//   }
// };
// useEffect(() => {
//   notes.forEach((note) => {
//     if (note.NotesPdf && note.NotesPdf.includes("pdf") && !pdfPreviews[note._id]) {
//       handlePdfPreview(note._id, note.NotesPdf);
//     }
//   });
// }, [notes, pdfPreviews]);


 
//   if (loading ) {
//     return (
//       <div className="grid min-h-[calc(100vh-3.5rem)] place-items-center">
//         <div className="spinner"></div>
//       </div>
//     );
//   }

//   // Handle case where no notes are found
//   if (!categoryId || catalogPageData?.success === false) {
//     return <UnderDevelopmentPage />;
//   }
//   const handleViewNotesDetail = (notesId)=>{
//     if(token){
//       fetchNotesFullDetails(notesId)
//     }
//     else{
// setConfirmationModal({
//   text1:"You are not logged in!",
//   text2:"Please login to View Notes Details.",
//   btn1Text:"Login",
//   btn1Handler:()=>navigate("/login"),
//   btn2Text:"Close",
//   btn2Handler:()=>setConfirmationModal(null),
// })
//     }

//   }
//   const handlePDFOpener = ()=>{
  
//     setConfirmationModal({
//   text1:"You are not logged in!",
//   text2:"Please login to Access Notes.",
//   btn1Text:"Login",
//   btn1Handler:()=>navigate("/login"),
//   btn2Text:"Close",
//   btn2Handler:()=>setConfirmationModal(null),
// })
    

//   }

//   return (
//     <>
//       {/* Hero Section */}
//       <div className="box-content bg-pure-greys-150 px-4">
//         <div className="mx-auto flex min-h-[260px] max-w-maxContentTab flex-col justify-center gap-4 lg:max-w-maxContent ">
//           <p className="text-sm text-richblack-800">
//             {`Home / notes / `}
//             <span className="text-pink-200 text-semibold  underline">
//               {catalogPageData?.selectedCategory?.name}
//             </span>
//           </p>
//           <p className="text-3xl text-richblack-600">
//             {catalogPageData?.selectedCategory?.name}
//           </p>
//           <p className="max-w-[870px] text-richblack-400">
//             {catalogPageData?.selectedCategory?.description}
//           </p>
//         </div>
//       </div>

//       {/* Notes Section */}
//       <div className="mx-auto box-content w-full max-w-maxContentTab px-4 py-12 lg:max-w-maxContent">
//         <div className="section_heading">Notes to get you started</div>
//         <Table className="text-white rounded-xl   bg-pure-greys-150 mt-10 ">
//           <Thead>
//             <Tr className="flex gap-x-10 rounded-t-md border-b border-b-white px-6 py-2">
//               <Th className=" hidden lg:flex-1 text-left  text-sm font-medium uppercase text-richblack-900">
//                 Notes
//               </Th>
//               <Th className="hidden lg:block text-center text-sm font-semibold font-medium uppercase text-richblack-900">
//                 View
//               </Th>
//             </Tr>
//           </Thead>
//           <Tbody>
//             {notes.length === 0 ? (
//               <Tr>
//                 <Td className="py-10 text-center text-2xl font-medium text-richblack-800">
//                   No Notes found🙂
//                 </Td>
//               </Tr>
//             ) : (
//               notes.map((note) => (
//                 <Tr key={note._id} className="flex gap-x-10 border-b border-white px-6 py-8">
//                   <Td className="flex flex-1 gap-x-4">
//                     <img
//                       src={pdfPreviews[note._id] || note.NotesPdf} // Show PDF preview or fallback to default PDF image
//                       alt={note.NotesName}
//                       className="h-[148px] w-[220px] rounded-lg object-cover text-richblack-800"
//                     />
//                     <div className="flex flex-col justify-between">
//                       <p className="text-lg font-semibold text-richblack-800">
//                         {note.NotesName}
//                       </p>
//                       <p className="text-xs text-richblack-900">
//                         Description: <span className="text-richblack-400">{note.NotesDescription?.substr(0, 30)}...</span>
//                       </p>
//                       <p className="text-[12px] text-richblack-900">
//                         Created: <span className="text-richblack-600 bg-richblack-5">{formatDate(note.createdAt)}</span>
//                       </p>
//                     </div>
//                   </Td>
//                   <Td className="flex flex-1 gap-x-4">
//                     <div className="flex justify-center items-center gap-4">
//                       <button
//                         className="px-6 py-3 bg-blue-100 hover:bg-blue-200 text-white mt-4 rounded-xl"
//                       >
//                         {token ? <button><PDFopener pdfUrl={note.NotesPdf} /></button> : <button onClick={handlePDFOpener}>Open pdf</button>}
//                       </button>
//                       <button
//                         className="px-6 py-3 bg-blue-100 hover:bg-blue-200 text-white mt-4 rounded-xl"
//                         onClick={() => handleViewNotesDetail(note._id)}
//                       >
//                         View Notes Details
//                       </button>
//                     </div>
//                   </Td>
//                 </Tr>
//               ))
              
//             )
            
//             }
//           </Tbody>
//         </Table>

//       {
//   instructorDetailModal && (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
//       <div className="w-full max-w-md rounded-xl bg-pure-greys-150 p-6 shadow-lg">
        
//         {/* Close Button */}
//         <button
//           onClick={() => setInstructorDetailModal(null)}
//           className="absolute top-4 right-4 text-pure-greys-400 hover:text-gray-200"
//         >
//           &times;
//         </button>
        
//         {/* Modal Content */}
//         <div className="space-y-4">
//           <p className="text-xl font-semibold text-richblack-900 capitalize">{selectedNoteDetails.NotesName}</p>
          
//           <p className="text-sm text-semibold text-richblack-900">
//             Description:
//             <span className="text-richblack-600"> {selectedNoteDetails.NotesDescription}</span>
//           </p>
          
//           <p className="text-sm font-medium text-blue-100 bg-richblack-700 rounded-md px-2 py-1 inline-block">
//             Category: {selectedNoteDetails?.category?.name || "N/A"}
//           </p>

//           <p className="text-sm  text-richblack-900 text-semibold">
//             Created:
//             <span className="text-xs"> {formatDate(selectedNoteDetails.createdAt)}</span>
//           </p>

//           <p className="text-xs text-blue-100 bg-richblack-700 rounded-md px-2 py-1 inline-block">
//             Published
//           </p>

//           {/* Instructor Info */}
//           <div className="flex items-center gap-3 mt-4">
//             <img
//               src={`https://api.dicebear.com/5.x/initials/svg?seed=${selectedNoteDetails.instructor.firstName} ${selectedNoteDetails.instructor.lastName}`}
//               alt={`${selectedNoteDetails.instructor.firstName} ${selectedNoteDetails.instructor.lastName}`}
//               className="h-12 w-12 rounded-full object-cover border border-pure-greys-100"
//             />
//             <div>
//               <p className="text-lg font-semibold text-white">
//                 {`${selectedNoteDetails.instructor.firstName} ${selectedNoteDetails.instructor.lastName}`}
//               </p>
//               <p className="text-xs text-blue-100">Instructor</p>
//             </div>
//           </div>
//         </div>
        
//         {/* Action Buttons */}
//         <div className="flex justify-end mt-6">
//           <button
//             onClick={() => setInstructorDetailModal(null)}
//             className="px-4 py-2 rounded-md bg-pink-600 text-white font-medium hover:bg-pink-500 transition"
//           >
//             Close
//           </button>
//         </div>
//       </div>
//     </div>
//   )
// }
 
       
//       </div>     
//       {
//         confirmationModal && <ConfirmationModal modalData={confirmationModal} />
//       }
//     </>
//   );
// }

// export default NotesCatalog;
